import { Dialog, DialogTitle, IconButton, Stack } from '@mui/material';
import Close from '@mui/icons-material/Close';
import type { ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

interface GenericDialogProps {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  disableBackdropClick?: boolean;
  disableEscapeKeyDown?: boolean;
  headerActions?: ReactNode;
  paperSx?: SxProps<Theme>;
}

export function GenericDialog({
  open,
  onClose,
  title,
  children,
  maxWidth = 'sm',
  fullWidth = false,
  disableBackdropClick = false,
  disableEscapeKeyDown = false,
  headerActions,
  paperSx
}: GenericDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={disableBackdropClick && disableEscapeKeyDown ? undefined : onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      disableEscapeKeyDown={disableEscapeKeyDown}
      slotProps={{
        paper: {
          sx: {
            width: fullWidth ? '100%' : 'auto',
            ...((paperSx as object) ?? {})
          }
        }
      }}
    >
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          {title}
          <Stack direction="row" gap={0.5} sx={{ flexShrink: 0 }}>
            {headerActions}
            <IconButton onClick={onClose} size="small">
              <Close />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      {children}
    </Dialog>
  );
}
